import React, { useContext as useContextCore } from 'react'

export type ProviderProps = {
  routeContext?: Record<string, any>
  children: React.ReactNode
}

export type AppContextType = Omit<ProviderProps, 'children'>

const context = React.createContext<AppContextType>({} as AppContextType)
const CoreProvider = context.Provider

export const AppProvider = ({ children, routeContext, ...props }: ProviderProps) => {
  return <CoreProvider value={{ ...props, routeContext: routeContext ?? {} }}>{children}</CoreProvider>
}

export const useAppContext = () => useContextCore(context)
